import React, { useContext, useState } from 'react';
import dayjs from 'dayjs';

import Button from '@material-ui/core/Button'

import AuthContext from '../../../services/firebase/AuthContext';
import ConfirmActionDialog from '../_common/ConfirmActionDialog';
import FireDataContext from '../../../services/firebase/FireDataContext';
import { keyGen } from '../../../services/keygen';
import { navigate } from '@reach/router';

const CloneReferralButton = ({ referralId }) => {
    
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);
    const [showConfirm, setShowConfirm] = useState(false);
    
    const cloneReferral = async () => {
        
        return new Promise(async (resolve, reject) => {
            try {
                const intermediaryId = currentUser.uid;

                // get the source referral
                const rfq = await db.get({ path: `intermediaries/${intermediaryId}/referrals/${referralId}`, context: 'CloneReferralButton' });
                const referral = await db.get({ path: rfq.referralPath });
        
                const id = keyGen(10);
        
                const referralClone = {
                    bookingReference: keyGen(10),
                    status: 'submitted',
                    organizationId: referral.organizationId,
                    courtCaseId: referral.courtCaseId,
                    referralType: referral.referralType,
                    location: referral.location,
                    tariff: referral.tariff || 'tier1',
                    vulnerabilities: referral.vulnerabilities,
                    uid: referral.uid,
                    ts: dayjs().valueOf()
                };
        
                const referralPath = `organizations/${referral.organizationId}/referrals/${id}`;
        
                const rfqClone = {
                    message: rfq.message + ` (cloned from ${referral.bookingReference})`,
                    intermediaryId,
                    organization: rfq.organization,
                    organizationId: referral.organizationId,
                    referralId: id,
                    referralPath,
                    status: 'new',
                    uid: intermediaryId,
                    ts: dayjs().valueOf(),
                };
        
                console.log('cloning ...', id, referralClone, rfqClone);

                await db.update({
                    path: referralPath,
                    payload: {
                        ...referralClone
                    }
                });
                
                // also need to add the intermediaries subcollection
                await db.update({
                    path: `${referralPath}/intermediaries/${intermediaryId}`,
                    payload: {
                        ...rfqClone
                    }
                });
                
                await db.update({
                    path: `intermediaries/${intermediaryId}/referrals/${id}`,
                    payload: {
                        ...rfqClone  
                    }
                });
    
                resolve(id);
            }
            catch (error) {
                reject(error);
            }
        })
        

    }

    const handleClick = () => {
        setShowConfirm(true);
    }

    const handleConfirm = () => {
        cloneReferral()
            .then(id => {
                setShowConfirm(false);
                navigate(`/`);
            })
            .catch(console.log);
    }

    const handleCancel = () => {
        setShowConfirm(false);
    }



    return (
        <React.Fragment>
            <Button onClick={handleClick} variant="outlined" color="default">
                Clone This Referral
            </Button>
            <ConfirmActionDialog
                visible={showConfirm}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                title="Please Confirm"
                message="When you click OK a new referral will be created using this one as a template. The referral will appear in your dashboard as 'new' and you can then quote for it in the usual way"
            />
        </React.Fragment>
    );
};

export default CloneReferralButton;